import { useEffect, useState, useContext } from "react";
import { createPortal } from "react-dom";
import { useSessionData } from "ui-components";

/* images */
import modelOne from "./images/model1.png";
import modelTwo from "./images/model2.png";
import modelThree from "./images/model3.png";
import modelFour from "./images/model4.png";
import modeFive from "./images/model5.png";
import modelSix from "./images/model6.png";
import modelSeven from "./images/model7.png";

/* components */
import PromoStep from "./components/PromoStep";
import GenderForm from "./components/GenderForm";
import BirthdayForm from "./components/BirthdayForm";
import NameForm from "./components/NameForm";
import EmailForm from "./components/EmailForm";
import PasswordForm from "./components/PasswordForm";
import { Footer } from "./components/Footer";
import PopUp from "./components/PopUp/index";

/* hooks */
import { useKeyboardScrollFix } from "./hooks/useKeyboardScrollFix";
import { useAppendLandingId } from "./hooks/useAppendLandingId";

import { ContextProfileUser } from "./lib/profileContext";
import { getTTI, sendScreenResolution, simplyClick } from "./helpers";
import { landingId } from "./constants/index";



function App() {

  let content = null;

  const [showPopUp, setShowPopUp] = useState(false);
  const footer = document.getElementById("footer");

  const [step, setStep] = useState(() => {
    const nav = performance.getEntriesByType("navigation")[0];
    const isReload = nav ? nav.type === "reload" : false;
    return isReload ? 1 : window.history.state?.step || 1;
  });

  useAppendLandingId(landingId);
  useKeyboardScrollFix();


  /* context */
  const { data, setData } = useContext(ContextProfileUser);
  const { getSessionData, saveSessionData } = useSessionData(landingId);

  useEffect(() => {
    const saved = getSessionData();
    if (saved) {
      setData(saved);
    }
  }, []);

  useEffect(() => {
    if (Object.keys(data).length > 0) {
      saveSessionData(data);
    }
  }, [data, saveSessionData]);

  useEffect(() => {
    const timer = setTimeout(() => {
      getTTI();
      sendScreenResolution();
    }, 5000);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    const images = [
      modelOne,
      modelTwo,
      modelThree,
      modelFour,
      modeFive,
      modelSix,
      modelSeven,
    ];

    images.forEach((src) => {
      const img = new Image();
      img.src = src;
    });
  }, []);


  useEffect(() => {
    const handlePopState = (event) => {
      const newStep = event.state?.step;
      if (newStep) setStep(newStep);
    };

    const handlePageShow = (event) => {
      if (event.persisted) {
        const newStep = window.history.state?.step;
        if (newStep) setStep(newStep);
      }
    };

    window.addEventListener("popstate", handlePopState);
    window.addEventListener("pageshow", handlePageShow);

    return () => {
      window.removeEventListener("popstate", handlePopState);
      window.removeEventListener("pageshow", handlePageShow);
    };
  }, []);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "auto" });
    const currentState = window.history.state;
    if (!currentState || currentState.step !== step) {
      window.history.replaceState({ ...currentState, step }, "");
    }
  }, [step]);


  const openPopUp = (e) => {
    if (e.target === e.currentTarget) {
      setShowPopUp(true);
      simplyClick("cl_lnd_photos", { text: `step(${step})` });
    }
  };

  const closePopUp = () => {
    setShowPopUp(false);
  };

  useEffect(() => {
    const registerGoogleContainer = document.querySelector(".content__wrapper");

    if (registerGoogleContainer && !showPopUp) {
      registerGoogleContainer.addEventListener("click", openPopUp);
    }

    return () => {
      if (registerGoogleContainer) {
        registerGoogleContainer.removeEventListener("click", openPopUp);
      }
    };
  }, [showPopUp, step]);


  useEffect(() => {
    const wrapper = document.querySelector(".content__wrapper");
    if (!wrapper) return;
    let position = 0;
    const speed = 0.5;
    let lastTimestamp = performance.now();
    let animationFrameId;
    const animateBg = (timestamp) => {
      const elapsed = timestamp - lastTimestamp;
      lastTimestamp = timestamp;
      position += speed * (elapsed / 16);
      wrapper.style.backgroundPosition = `${position}px 56px`;
      animationFrameId = requestAnimationFrame(animateBg);
    };
    animationFrameId = requestAnimationFrame(animateBg);
    return () => cancelAnimationFrame(animationFrameId);
  }, []);

  switch (step) {
    case 2:
      content = (
        <>
          <GenderForm nextStep={() => setStep(3)} />
        </>
      );
      break;

    case 3:
      content = (
        <>
          <BirthdayForm nextStep={() => setStep(4)} />
        </>
      );
      break;
    case 4:
      content = (
        <>
          <NameForm nextStep={() => setStep(5)} />
        </>
      );
      break;
    case 5:
      content = (
        <>
          <EmailForm nextStep={() => setStep(6)} />
        </>
      );
      break;
    case 6:
      content = (
        <>
          <PasswordForm nextStep={() => setStep(7)} />
        </>
      );
      break;
    default:
      content = (
        <>
          <PromoStep nextStep={() => setStep(2)} />
        </>
      );
      break;
  }

  return (
    <>
      <>
        {content}
        {showPopUp && <PopUp step={step} closePopUp={closePopUp} />}
      </>
      {footer && createPortal(<Footer step={step} />, footer)}
    </>
  );
}

export default App;
